import { EMOJI_CATALOGUE } from './emoji-catalogue';

export { EMOJI_CATALOGUE, type EmojiGroup } from './emoji-catalogue';

/**
 * The subset offered straight from a message's own menu.
 *
 * Seven, because a long press should answer in one tap and a grid of nineteen
 * hundred does not. The full catalogue is one control away.
 */
export const QUICK_REACTIONS = ['👍', '❤️', '😂', '🔥', '😭', '😍', '👌'] as const;

/** Flattened, for anything that needs to ask whether a string is an emoji. */
export const ALL_EMOJI: readonly string[] = EMOJI_CATALOGUE.flatMap((group) => group.emoji);
